// src/contexts/SidebarContext.jsx - New Version for Frontend v2
import React, { createContext, useContext, useState, useEffect } from 'react';

const SidebarContext = createContext();

export const useSidebar = () => {
  const context = useContext(SidebarContext);
  if (!context) {
    throw new Error('useSidebar must be used within a SidebarProvider');
  }
  return context;
};

export const SidebarProvider = ({ children }) => {
  // Initialize state from localStorage or default to false (expanded)
  const [isCollapsed, setIsCollapsed] = useState(() => {
    // Only access localStorage on client side
    if (typeof window !== 'undefined') {
      const saved = localStorage.getItem('sidebarCollapsed');
      return saved === 'true';
    }
    return false; // Default to expanded on server-side rendering
  });

  // Update body class and save to localStorage when state changes
  useEffect(() => {
    // Add/remove body class for CSS-based responsive adjustments
    document.body.classList.toggle('sidebar-collapsed', isCollapsed);
    
    // Persist state to localStorage
    localStorage.setItem('sidebarCollapsed', isCollapsed.toString());
  }, [isCollapsed]);

  // Toggle function
  const toggleSidebar = () => {
    setIsCollapsed(prev => !prev);
  };

  // Manual setter function (useful for programmatic control)
  const setSidebarCollapsed = (collapsed) => {
    setIsCollapsed(collapsed);
  };

  const value = {
    isCollapsed,
    toggleSidebar,
    setIsCollapsed: setSidebarCollapsed
  };

  return (
    <SidebarContext.Provider value={value}>
      {children}
    </SidebarContext.Provider>
  );
};